import './App.css';

const Block_projects = () => {

  const links = [
    {
      url: "https://blockchainsimpleproject.netlify.app/",
      imgSrc: "blockchain.jpeg",
      text: "Auth with Metamask & Connect to Network",
    },
    {
      url: "https://voting-system10.netlify.app/",
      imgSrc: "voting.jpg",
      text: "Decentralized Voting System",
    },
  ];

  return (
    <>
      <div id="dynamicLinks">
      <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Web-3.0 Projects blockchain Technology</p>
        {links.map((link, index) => (
          <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
            <div className="main-child">
              <div className="img-view">
                <img src={link.imgSrc} alt={link.text} />
              </div>
              <div className="text">
                <p>{link.text}</p>
              </div>
            </div>
          </a>
        ))}
      </div>

    </>
  );
};

export default Block_projects;
